import {
  ADD_TASK_LABEL,
  REMOVE_TASK_LABEL,
  UPDATE_TASK_LABEL,
  SET_LABEL_FILTERS,
  SET_MINDSET,
  SET_SORT_ORDER,
  SET_TASK_LABELS,
  SET_USER,
  SET_LOADING_USER,
  SET_USER_AUTHENTICATED,
  SET_AUTH_STATE,
  SET_USER_SUBSCRIPTION,
  SET_MESSAGES,
  SET_TASK_CREATION_PREFERENCE,
} from "../constants/user";

const initialValue = {
  activeUser: undefined,
  loadingUser: false,
  authenticated: false,
  authState: "checking", // 'checking' | 'authenticated' | 'unauthenticated'
  subscription: null,
  mindset: {
    mood: 5,
    energy: 5,
  },
  labels: {},
  filters: {
    labels: {},
  },
  sortOrder: "adaptive",
  taskCreationPreference: null,
};

export default (state = initialValue, action) => {
  switch (action.type) {
    case SET_USER:
      const user = action.user;
      if (!user)
        return {
          ...state,
          activeUser: null,
        };
      return {
        ...state,
        activeUser: {
          ...action.user,
          firstName: action.user.displayName.split(" ")[0],
        },
      };

    case SET_LOADING_USER:
      return {
        ...state,
        loadingUser: action.loadingUser,
      };
    case SET_USER_AUTHENTICATED: {
      return {
        ...state,
        authenticated: action.status,
      };
    }
    case SET_AUTH_STATE: {
      return {
        ...state,
        authState: action.authState,
      };
    }
    case SET_USER_SUBSCRIPTION: {
      return {
        ...state,
        subscription: action.subscription,
      };
    }
    case SET_MINDSET: {
      return {
        ...state,
        mindset: action.mindset,
      };
    }
    case SET_TASK_LABELS:
      return {
        ...state,
        labels: action.labels || {},
      };
    case ADD_TASK_LABEL: {
      const newLabels = { ...state.labels };
      const { labelId, label } = action;
      newLabels[labelId] = {
        ...label,
        labelId: labelId,
      };
      return {
        ...state,
        labels: newLabels,
      };
    }
    case REMOVE_TASK_LABEL: {
      const newLabels = { ...state.labels };
      const { labelId } = action;
      delete newLabels[labelId];
      return {
        ...state,
        labels: newLabels,
      };
    }
    case UPDATE_TASK_LABEL: {
      const { labelId, updates } = action;
      if (!state.labels[labelId]) {
        return state;
      }
      return {
        ...state,
        labels: {
          ...state.labels,
          [labelId]: {
            ...state.labels[labelId],
            ...updates,
          },
        },
      };
    }
    case SET_LABEL_FILTERS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          labels: {
            ...state.filters.labels,
            ...action.labelFilters,
          },
        },
      };
    }
    case SET_SORT_ORDER: {
      return {
        ...state,
        sortOrder: action.sortOrder,
      };
    }
    case SET_TASK_CREATION_PREFERENCE: {
      return {
        ...state,
        taskCreationPreference: action.taskCreationPreference,
      };
    }
    default:
      return state;
  }
};
